import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { usePopper } from 'react-popper';
import classNames from 'classnames';

const calculateHeight = (items, hideAdd) => (items.length > 3 ? 51 * 4 : 51 * (items.length || 1)) + 1 + (hideAdd ? 0 : 36);
const popperStyle = { zIndex: 1100 };

export default function SkuSearchResultsWrapper({ inline, items, isOpen, children, searchRef, hideAdd, boundary = 'body' }) {
  // const [width, setWidth] = useState(0);
  const [popperElement, setPopperElement] = useState(null);
  const { styles, attributes } = usePopper(searchRef, popperElement, {
    placement: 'bottom-end',
    strategy: inline === 'absolute' ? 'absolute' : 'fixed',
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 10]
      }
    },
    {
      name: 'preventOverflow',
      options: {
        padding: 10,
        boundary
      }
    },
    {
      name: 'flip',
      options: {
        padding: 10,
        boundary
      }
    }]
  });

  const inlinePopper = (
    <div
      ref={setPopperElement}
      className={classNames('SkuSearchResultsWrapper', 'shadow', 'popover-popper', { 'popover-popper--hidden': !isOpen })}
      style={{ ...styles.popper, ...popperStyle, height: calculateHeight(items, hideAdd), width: 1200 }}
      {...attributes.popper}
    >
      {children}
    </div>
  );

  if (inline) {
    if (inline === 'absolute' || typeof document === 'undefined')
      return inlinePopper;

    return createPortal(inlinePopper, document.body);
  }

  return (
    <div className="d-flex flex-column flex-grow-1 mt-3">
      {children}
    </div>
  );
}